var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427319616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.69231 0C2.96204 0 2.24817 0.21655 1.64097 0.622266C1.03378 1.02798 0.560524 1.60464 0.281062 2.27932C0.00159985 2.954 -0.0715201 3.6964 0.0709483 4.41264C0.213417 5.12888 0.565075 5.78678 1.08145 6.30316C1.59783 6.81954 2.25574 7.1712 2.97197 7.31367C3.68821 7.45613 4.43061 7.38301 5.10529 7.10355C5.77997 6.82409 6.35663 6.35084 6.76235 5.74364C7.16806 5.13644 7.38461 4.42257 7.38461 3.69231C7.38461 2.71305 6.9956 1.77389 6.30316 1.08145C5.61072 0.38901 4.67157 0 3.69231 0Z",
    fill: "#1AD393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.308 7.38461C13.0383 7.38461 13.7522 7.16806 14.3594 6.76235C14.9666 6.35663 15.4398 5.77997 15.7193 5.10529C15.9987 4.43061 16.0719 3.68821 15.9294 2.97197C15.7869 2.25574 15.4353 1.59783 14.9189 1.08145C14.4025 0.565075 13.7446 0.213417 13.0284 0.0709483C12.3121 -0.0715202 11.5697 0.00159982 10.895 0.281062C10.2204 0.560524 9.6437 1.03378 9.23799 1.64097C8.83227 2.24817 8.61572 2.96204 8.61572 3.69231C8.61572 4.67157 9.00473 5.61072 9.69717 6.30316C10.3896 6.9956 11.3288 7.38461 12.308 7.38461Z",
    fill: "#1AD393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.308 8.61523C11.5778 8.61523 10.8639 8.83178 10.2567 9.2375C9.6495 9.64322 9.17625 10.2199 8.89678 10.8946C8.61732 11.5692 8.5442 12.3116 8.68667 13.0279C8.82914 13.7441 9.1808 14.402 9.69718 14.9184C10.2136 15.4348 10.8715 15.7864 11.5877 15.9289C12.3039 16.0714 13.0463 15.9982 13.721 15.7188C14.3957 15.4393 14.9724 14.9661 15.3781 14.3589C15.7838 13.7517 16.0003 13.0378 16.0003 12.3075C16.0003 11.3283 15.6113 10.3891 14.9189 9.69669C14.2264 9.00424 13.2873 8.61523 12.308 8.61523Z",
    fill: "#1AD393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.69231 8.61523C2.96204 8.61523 2.24817 8.83178 1.64097 9.2375C1.03378 9.64322 0.560524 10.2199 0.281062 10.8946C0.00159985 11.5692 -0.0715201 12.3116 0.0709483 13.0279C0.213417 13.7441 0.565075 14.402 1.08145 14.9184C1.59783 15.4348 2.25574 15.7864 2.97197 15.9289C3.68821 16.0714 4.43061 15.9982 5.10529 15.7188C5.77997 15.4393 6.35663 14.9661 6.76235 14.3589C7.16806 13.7517 7.38461 13.0378 7.38461 12.3075C7.38461 11.3283 6.9956 10.3891 6.30316 9.69669C5.61072 9.00424 4.67157 8.61523 3.69231 8.61523Z",
    fill: "#1AD393"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedOverview);
export default __webpack_public_path__ + "static/media/SelectedOverview.84bf6bdaa4051a4ef5bcbc13f4d18ad4.svg";
export { ForwardRef as ReactComponent };